var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"important-calendar",class:_vm.invalidClass,attrs:{"data-error":_vm.invalid}},[_c('input',_vm._b({class:_vm.className,attrs:{"type":"date","name":"date","required":""},domProps:{"value":_vm.value},on:{"input":_vm.emitCalendar}},'input',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }